import { useSendTransaction, SendTransactionVariables } from '@safe-global/safe-react-hooks'
import { SubmitBtn } from '../../styles/ds'
import { getAddress } from 'viem'
import React from 'react'
import { safeTransactionUrl } from 'src/utils/web3-utils'
import { CHAIN_INFO } from 'src/constants/networks'
import { useApi } from '../../hooks/useApi'


interface EncodedChange {
  [key: string]: { data: string }[]
}

interface Props {
  encodedChanges: EncodedChange[] | null
  setStatus: (status: string) => void
  startChanges?: unknown
  endChanges?: unknown
  safeAddress?: string
  chainId?: number
  namespace?: string
  metadata?: string
  mimicId?: string
  itemId?: string

}

const SendTransaction: React.FC<Props> = ({
  encodedChanges,
  setStatus,
  startChanges,
  endChanges,
  safeAddress,
  chainId,
  namespace,
  metadata,
  mimicId,
  itemId
}) => {
  const { sendTransactionAsync } = useSendTransaction()
  const { callApi } = useApi()

  if (!encodedChanges) return null

  const handleSendTransaction = async () => {
    const processedEncodedChanges = encodedChanges.flatMap((change) => {
      const address = Object.keys(change)[0]
      const dataArray = change[address]
      return dataArray.map((calldata) => ({
        to: getAddress(address),
        value: '0',
        data: calldata,
      }))
    })

    const safeTransactionData = [
      ...(Array.isArray(startChanges) ? startChanges : []),
      ...processedEncodedChanges,
      ...(Array.isArray(endChanges) ? endChanges : []),
    ]

    const sendTransactionParams: SendTransactionVariables = {
      transactions: safeTransactionData,
    }

    console.log('tx', sendTransactionParams)

    try {
      const result = await sendTransactionAsync(sendTransactionParams)
      const safeTxHash = result?.transactions?.safeTxHash
      console.log('Transaction sent successfully! safeTxHash:', safeTxHash)
      setStatus(JSON.stringify(result))
      if (safeTxHash) {
        notifyDiscordWebhook(safeTxHash, safeAddress, chainId, namespace, metadata)
        submitEnvironmentUpdate(safeTxHash, itemId, callApi)
      }
    } catch (error) {
      console.error('Transaction failed:', error)
      setStatus(`Error: ${error?.message ?? error}`)
    }
  }

  return <SubmitBtn onClick={handleSendTransaction}>Send SAFE Transaction</SubmitBtn>
}

const DISCORD_WEBHOOK_URL = process.env.REACT_APP_DISCORD_WEBHOOK_URL

async function notifyDiscordWebhook(
  hash: string,
  safeAddress: string,
  chainId: number,
  namespace: string,
  metadata: string
) {
  if (!DISCORD_WEBHOOK_URL) {
    console.log('📭 No Discord webhook URL configured, skipping notification.')
    return
  }

  try {
    const linkTx = safeTransactionUrl(chainId, safeAddress) + '_' + hash
    const chainName = CHAIN_INFO[chainId]?.name
    await fetch(DISCORD_WEBHOOK_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        content: `✍️ New Safe transaction for **${namespace}** (${chainName}) :

> ${metadata} 

${linkTx}`,
      }),
    })
    console.log('✅ Discord notification sent')
  } catch (err) {
    console.error('❌ Failed to send Discord notification:', err)
  }
}

export default SendTransaction

async function submitEnvironmentUpdate(safeTxHash: string, updateId: string, callApi: unknown) {
  try {
    const approveResponse = await callApi(`/environments/updates/${updateId}/submit`, { safeTxHash }, 'POST')
    console.log('✅ Environment update submitted:', approveResponse)
  } catch (err) {
    console.error('❌ Failed to submit environment update:', err)
  }
}


